export default __webpack_public_path__ + "static/media/user.a6143582.png";